const EXCEPTION_ERROR_MESSAGE = 'エラーが発生しました。再度画面読み込み直してもエラーが解消されない場合は運営へお問い合わせください。';
const RESOLVED_ERROR_MESSAGE = '【解決】';

/**
 * フラッシュメッセージ機能を導入するmixin。
 *
 *  メッセージ発生箇所と表示箇所にmixinさせて使用する。
 *  自身から親コンポーネントへ再帰的にdata.messageを探し、
 *  最初に見つけた箇所へ代入、そのコンポーネント内のフラッシュメッセージタグで表示する。
 *
 *   this.appendFlashMessage({
 *       level: 'bootstrapのクラス',
 *       message: "メッセージ",
 *       autoClear: true
 *   });
 *
 *   .alert-info    ⇒>成功
 *   .alert-success ⇒>エラー修正
 *   .alert-danger  ⇒>エラー
 */
export default {
    data() {
        return {
            // 例外エラーの定型文
            exception_error_message: EXCEPTION_ERROR_MESSAGE,
            // propsに渡す用のフラッシュメッセージ配列
            messages: []
        };
    },
    components: {
        'flash-message': {
            template: '#flash_message_component_template',
            props: {
                /**
                 * 表示中のフラッシュメッセージ
                 */
                messages: {
                    type: Array,
                    require: true
                }
            },
            emits: ['clear'],
            methods: {
                /**
                 * フラッシュメッセージを1つ閉じる
                 */
                emitClear: function (event) {
                    const index = event.currentTarget.parentNode.getAttribute('data-id');
                    this.$emit('clear', {index: index});
                }
            }
        }
    },
    watch: {
        /**
         * オートクリア指定されているメッセージを削除
         */
        'messages': {
            handler: function () {
                setTimeout(() => {
                    this.messages.forEach((message, index) => {
                        if (typeof message.autoClear !== 'undefined' && message.autoClear === true) {
                            this.clearFlashMessage({index: index});
                        }
                    });
                }, 2000);
            },
            deep: true
        }
    },
    emits: ['clear'],
    methods: {
        /**
         * 例外発生時のメッセージを判別して返す
         */
        getCatchMessage: function (error) {
            console.log(error);
            if (!error.response || !error.response.status) {
                // error.response が未定義の場合、デフォルトのエラーメッセージを返す
                return this.exception_error_message;
            }
            switch (error.response.status){
                case 401:
                    return 'サインインし直してください';
                case 422:
                    // バリデーションエラーの場合はerror.response.dataを渡す
                    return error.response.data;
                default:
                    return this.exception_error_message;
            }
        },
        /**
         * メッセージを追加
         *
         * 自身から親コンポーネントへ再帰的に
         * data.messageを探し最初に見つかった場所へ代入させる。
         *
         * @param messages 追加するメッセージオブジェクト
         * @param instance 親コンポーネントのインスタンス(初回はundefined)
         */
        appendFlashMessage: function(messages, instance) {
            if (!instance) {
                instance = this;
            }
            if (typeof instance?.messages !== 'undefined') {
                this.adjustMessage(messages, instance.messages);
            // メッセージがなければ再帰的に親コンポーネントを辿る(undefined判定で無限ループ防止)
            } else if (instance?.$parent) {
                this.appendFlashMessage(messages, instance.$parent);
            }
        },
        /**
         * フラッシュメッセージを全解決済にする
         *
         */
        allResolvedFlashMessage: function (instance) {
            this.appendFlashMessage(null, instance);
        },
        /**
         * フラッシュメッセージを削除(表示をクローズ)
         *
         * @param payload {index | undefined}
         * @param payload.index 削除するメッセージの state.messages 中での位置(配列添字)。無指定の場合全件削除
         * @param instance {object | undefined}
         */
        clearFlashMessage: function(payload = null, instance = null) {
            if (!instance) {
                instance = this;
            }
            if (typeof instance?.messages !== 'undefined') {
                if (typeof payload?.index !== 'undefined') {
                    instance.messages.splice(payload.index, 1);
                } else {
                    instance.messages = [];
                }
            // メッセージがなければ再帰的に親コンポーネントを辿る(undefined判定で無限ループ防止)
            } else if (instance?.$parent){
                this.clearFlashMessage(payload, instance.$parent);
            }
        },
        /**
         * メッセージデータを調整
         * 配列の場合は1メッセージとして一つずつ追加する
         *
         * @param payload 追加するメッセージオブジェクト
         * @param messages 対象コンポーネントのdata.messages
         */
        adjustMessage: function(payload, messages) {
            // 新メッセージを1つずつ配列に入れ用意する
            let newMessages = [];
            if (payload) {
                if(payload.message?.errors){
                    console.log('バリデーションエラーメッセージあり');
                    payload.message = this.makeArrayMessage(payload);
                }
                if (Array.isArray(payload.message)) {
                    payload.message.forEach((message) => {
                        // アラートメッセージオブジェクト一つに対してメッセージを一つ設定するようにするため、メッセージの数分オブジェクト(config)を生成する。
                        let config = _.cloneDeep(payload);
                        config.message = message;
                        newMessages.push(config);
                    });
                } else {
                    newMessages.push(payload);
                }
            }
            // 旧メッセージが新メッセージに含まれているかチェック
            messages.forEach((message, index) => {
                let resolved = true;
                newMessages = newMessages.filter((newMessage) => {
                    if (message.message === newMessage.message) {
                        resolved = false;
                        return false;
                    }
                    return true;
                });
                // 重複が無かったら修正済として自動で削除
                if (resolved) {
                    messages[index] = {
                        ...messages[index],
                        message: RESOLVED_ERROR_MESSAGE + messages[index].message,
                        level: 'alert-success',
                        autoClear: true
                    };
                }
            });
            // 新メッセージを追加
            newMessages.forEach((newMessage) => {
                messages.push(newMessage);
            });
        },
        /**
         * 配列エラーメッセージの「＊」を数字に置き換える
         * @param payload
         * @returns {Array}
         */
        makeArrayMessage: function(payload) {
            let messages = [];
            const errors = payload.message?.errors || {};

            Object.entries(errors).forEach(([key, value]) => {
                let message = value[0];
                const indexes = key.split('.');
                if (indexes) {
                    indexes.forEach((index) => {
                        if (/^[0-9]*$/.test(index)) {
                            message = message.replace('*', parseInt(index) + 1);
                        }
                    });
                }
                messages.push(message);
            });

            return messages;
        }
    }
};
